import { List } from 'immutable';
import * as THREE from 'three';
import { PolyMesh, Selection, PolyMap, PolyMaps } from '../../polyMesh';

function stringIndicesToArray(str='') {
  const indices = str.split(',');
  let outIndices = [];
  let i, j, start, end, v;
  for (i = 0; i < indices.length; i++) {
    v = indices[i];
    if (v.indexOf('-') !== -1) {
      [start, end] = v.split('-');
      start = Number(start);
      end = Number(end);
      for (j = start; j <= end; j++) {
        outIndices.push(j);
      }
    } else {
      outIndices.push(Number(v));
    }
  }

  return outIndices;
}

const TransformVertices = {
  schema: {
    translation: { label: 'Translation', type: 'Vec3', step: 0.1, defaultValue: { x: 0, y: 0, z: 0 }, animatable: true },
    rotation: { label: 'Rotation', type: 'Vec3', step: 1, defaultValue: { x: 0, y: 0, z: 0 }, animatable: true, hidden: true },
    scale: { label: 'Scale', type: 'Vec3', minValue: 0.0001, step: 0.1, defaultValue: { x: 1, y: 1, z: 1 }, animatable: true, hidden: true },
    updateNormals: { label: 'Update Normals', type: 'Boolean', defaultValue: true, hidden: true },
    //centerType: { label: 'Center', type: 'Options', display: 'Dropdown',
    //      labels: ['Selection Center', 'World Center', 'Pivot'],
    //      values: ['SelectionCenter', 'WorldCenter', 'Pivot'],
    //      defaultValue: 'SelectionCenter' },
    //// matrix is used in baking transform and overrides other parameters
    //matrix: { label: 'Translation', type: 'Object', defaultValue: null, hidden: true },
    vertexIndices: { label: 'Selection', type: 'String', defaultValue: '' },
  },

  update: function (operator, primitive) {
    const mesh = primitive.mesh;
    if (!mesh) return primitive;

    const seed = Math.random();
    const density = 0.5;
    const meaning = Selection.Vertices;

    const indices = stringIndicesToArray(operator.vertexIndices);
    //console.log('create selection from: ', operator.vertexIndices, indices);

    const selection = new Selection(indices, Selection.Vertices);

    const newMesh = new PolyMesh(mesh);
    const newPolyMap = new PolyMap(PolyMaps.resolveMap(mesh, 'positions'));
    const newMapValues = newPolyMap.values.clone();
    newPolyMap.values = newMapValues;
    PolyMaps.assignMap(newMesh, 'positions', newPolyMap);

    const vertexIndices = Selection.getIndices(mesh, Selection.Vertices, 'positions', selection);

    const nonuniform = !!selection;

    for (let j = 0, n = vertexIndices.length; j !== n; ++j) {
      const i = vertexIndices[j];

      newMapValues.setAt(i,
          newMapValues.getAt(i, new THREE.Vector3()).add(operator.translation));
    }

    primitive.mesh = newMesh;
  },
};

export default TransformVertices;




// WEBPACK FOOTER //
// ./src/operators/PolyMesh/TransformVertices.js